<!-- 顶部logo页面 -->
<template>
  <div class="head-logo" :class="classObj">
    <div class="center-box">
      <div class="fl">
        <hamburger
          v-if="device === 'mobile'"
          :is-active="sidebar.opened"
          class="hamburger-container"
          @toggleClick="toggleSideBar"
        />
        <div
          v-if="device === 'mobile' && sidebar.opened"
          class="drawer-bg"
          @click="handleClickOutside"
        />
        <sidebar class="sidebar-container" v-if="device === 'mobile'" />
      </div>

      <div
        class="fl school-sign"
        @click="jumpTo('Home', '1')"
        v-if="device !== 'mobile'"
      >
        <img :src="logoImg" alt="校徽" class="badge" />
        <img src="./../../assets/24.gif" alt="校语" class="tell" />
      </div>
      <div class="fr">
        <p class="user">
          欢迎，{{ phone() }} |
          <el-dropdown @command="handleCommand" style="display:inline-block">
            <span class="el-dropdown-link">
              账号管理
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">退出登录</el-dropdown-item>
              <el-dropdown-item command="b" v-if="opTypes == 2"
                >绑定微信</el-dropdown-item
              >
              <el-dropdown-item command="c">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </p>
      </div>
    </div>

    <el-dialog title="二维码授权" :visible.sync="dialogVisibleWechat">
      <div class="dialog-content">
        <iframe :src="url" frameborder="0" width="100%"></iframe>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisibleWechat = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="重置密码框"
      :visible.sync="centerDialogVisible4"
      width="600px"
      center
      custom-class="dialogs2"
    >
      <div class="password-box">
        <h2>重置密码</h2>
        <div class="items2">
          <span>手机号码</span>
          <input type="text" placeholder="请输入手机号码" v-model="phones" />
        </div>
        <div class="items2">
          <span>验证码</span>
          <input
            type="text"
            placeholder="请输入验证码"
            class="code"
            v-model="codes"
          />
          <h4 v-show="show10" @click="sendCode">获取验证码</h4>
          <h4 v-show="!show10">{{ count }}秒</h4>
        </div>
        <div class="items2">
          <span>新密码</span>
          <input
            type="password"
            placeholder="请输入新密码"
            v-model="newPass1"
          />
        </div>
        <div class="items2">
          <span>确认新密码</span>
          <input
            type="password"
            placeholder="请输入确认新密码"
            v-model="newPass2"
          />
        </div>
        <div class="items2">
          <button @click="submitPass">确认</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Sidebar } from "@/layout/components";
import Hamburger from "@/components/Hamburger";
import ResizeMixin from "@/layout/mixin/ResizeHandler";
import router, { resetRouter, defaultRoutes, newRoutes } from "./../../router";
import {
  removeActive2,
  getPhone,
  getUid,
  getToken,
  removePhone,
  removeType,
  removeToken,
  getOpid,
  setOpid,
} from "@/utils/auth";
import { getSiteInfo, sendCode, alterPassword } from "@/api/home";
import encrypt from "./../../utils/encrypt";
import { getWxUserInfo } from "@/api/common";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Sidebar, Hamburger },
  data() {
    //这里存放数据
    return {
      show10: true,
      count: "",
      timer2: null,
      phones: "",
      codes: "",
      newPass1: "",
      newPass2: "",
      centerDialogVisible4: false,
      dialogVisibleWechat: false,
      uid: "",
      logoImg: "",
      url: "",
      opTypes: "",
      timer: null,
    };
  },
  mixins: [ResizeMixin],
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["sidebar"]),
    opType() {
      return getOpid();
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    activeItem() {
      return this.$store.state.user.activeItem;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  //监控data中的数据变化
  watch: {
    opType: {
      handler(newName, oldName) {
        this.opTypes = newName;
      },
      deep: true,
    },
    dialogVisibleWechat(newName, oldName) {
      if (newName == false) {
        clearInterval(this.timer);
      }
    },
  },
  //方法集合
  methods: {
    sendCode() {
      if (this.phones == "") {
        this.$message.info("手机号不得为空");
      } else {
        const TIME_COUNT = 60;
        if (!this.timer2) {
          sendCode({ mobile: this.phones }).then((response) => {
            this.$message.success("验证码获取成功");
          });
          this.count = TIME_COUNT;
          this.show10 = false;
          this.timer2 = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show10 = true;
              clearInterval(this.timer);
              this.timer2 = null;
            }
          }, 1000);
        }
      }
    },
    submitPass() {
      if (this.phones == "") {
        this.$message.info("手机号不得为空");
      } else if (this.codes == "") {
        this.$message.info("验证码不得为空");
      } else if (this.newPass1 == "") {
        this.$message.info("新密码不得为空");
      } else if (this.newPass2 == "") {
        this.$message.info("确认新密码不得为空");
      } else if (this.newPass1 != this.newPass2) {
        this.$message.info("新密码和确认新密码不一致,请重新填写");
      } else {
        let token = getToken();
        let uid = getUid();
        let data = {
          type: 1,
          method: 1,
          mobile: this.phones,
          code: this.codes,
          password: this.newPass2,
          uid: getUid(),
        };
        data = encrypt.Encrypt(JSON.stringify(data), token);
        token = encrypt.Encrypt(JSON.stringify(token), "");
        let params = {
          data: data,
          token: token,
        };
        alterPassword(params)
          .then((response) => {
            this.$message.success("密码修改成功,请重新登录");
            this.centerDialogVisible4 = false;
            resetRouter();
            router.addRoutes(defaultRoutes);
            router.options.routes = defaultRoutes;
            removeActive2();
            removeType();
            removeToken();
            removePhone();
            this.$router.push({ name: "Home" });
          })
          .catch((error) => {
            this.$message.error(error.msg);
          });
      }
    },
    setTime() {
      this.timer = window.setInterval(() => {
        setTimeout(this.getList1(), 0);
      }, 3000);
    },

    getList1() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
        type: 1,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getWxUserInfo(params).then(async (response) => {
        this.dialogVisibleWechat = false;
        this.opTypes = 1;
        setOpid(1);
        clearInterval(this.timer);
        this.timer = null;
        this.$message.success(response.msg);
      });
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    phone() {
      if (getPhone() != "" && getPhone() != null) {
        return getPhone();
      } else {
        return "微信登录";
      }
    },
    handleCommand(command) {
      if (command == "a") {
        resetRouter();
        router.addRoutes(defaultRoutes);
        router.options.routes = defaultRoutes;
        removeActive2();
        removeType();
        removeToken();
        removePhone();
        this.$router.push({ name: "Home" });
      } else if (command == "b") {
        var uids = getUid();
        var params = {
          uid: uids,
          type: 1,
        };
        var data1 = encrypt.Encrypt(JSON.stringify(params), "");
        this.url = "";
        this.url = "https://api.nbjss.com/api/port/wxAuthCode?data=" + data1;
        this.uid = uids;
        this.dialogVisibleWechat = true;
        this.setTime();
      } else if (command == "c") {
        this.centerDialogVisible4 = true;
        this.phones = "";
        (this.codes = ""), (this.newPass1 = ""), (this.newPass2 = "");
      }
    },
    fetchData() {
      getSiteInfo({ type: 1 }).then((response) => {
        this.logoImg = response.data.logo_img;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
    this.opTypes = getOpid();
  },
  beforeDestroy() {
    //页面关闭前关闭定时器 （这个才有用）
    clearInterval(this.timer);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.head-logo {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.hamburger-container {
  display: flex;
  align-items: center;
  line-height: 46px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  font-size: 17px;
}
.el-icon-arrow-down {
  font-size: 17px;
}
.head-logo {
  height: 135px;
  background-color: #0e56a0;
  .fl {
    height: 100%;
    display: flex;
    align-items: center;
    .badge {
      @media screen and (max-width: 950px) {
        display: none;
      }
      width: 100px;
      height: 100px;
      margin-right: 30px;
    }
    .tell {
      @media screen and (max-width: 1200px) {
        display: none;
      }
    }
  }
  .school-sign {
    cursor: pointer;
  }
  .fr {
    width: 250px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .user {
      font-size: 17px;
      @media screen and (max-width: 1200px) {
        font-size: 16px;
      }
      @media screen and (max-width: 950px) {
        font-size: 14px;
      }
      @media screen and (max-width: 768px) {
        font-size: 13px;
      }
      span {
        cursor: pointer;
        font-size: 17px;
        @media screen and (max-width: 1200px) {
          font-size: 16px;
        }
        @media screen and (max-width: 950px) {
          font-size: 14px;
        }
        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
